import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52aaed0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center mb-8" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Öğrenci Detayı"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-2" })
], -1))
const _hoisted_2 = {
  key: 0,
  class: "flex items-center space-x-4"
}
const _hoisted_3 = { class: "flex flex-row gap-4 h-full w-full" }
const _hoisted_4 = { class: "w-1/4 p-4 bg-white rounded-md shadow" }
const _hoisted_5 = { class: "pb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-indigo-500 fill-current h-4 w-4 mr-2",
  viewBox: "0 0 320 512",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" })
], -1))
const _hoisted_7 = { class: "flex flex-row items-center gap-4" }
const _hoisted_8 = { class: "text-2xl font-bold mb-4" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Okul Numarası", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Cinsiyet / Doğum Tarihi"),
  /*#__PURE__*/_createElementVNode("p", null, "Erkek / 2008")
], -1))
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Açıklama", -1))
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Kayıt Tarihi", -1))
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Veli Bilgileri", -1))
const _hoisted_18 = { class: "mb-2 p-3 text-sm border border-indigo-200 rounded-md bg-indigo-100" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "block" }
const _hoisted_22 = { class: "p-3 text-sm border border-indigo-200 rounded-md bg-indigo-100" }
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "block" }
const _hoisted_26 = { class: "w-3/4 p-4 bg-white rounded-md shadow" }
const _hoisted_27 = {
  key: 0,
  class: "mt-2 mb-4 relative flex w-full p-3 text-sm border border-orange-200 text-slate-600 rounded-md bg-orange-50"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  class: "h-5 w-5 mr-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
  })
], -1))
const _hoisted_29 = { class: "flex flex-col gap-2" }
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = { class: "pb-4" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold pb-4" }, "Yapay Zeka Eğitim Verisi", -1))
const _hoisted_33 = { class: "flex justify-end" }
const _hoisted_34 = { class: "flex flex-col w-full overflow-scroll text-gray-700 bg-white shadow rounded-sm bg-clip-border" }
const _hoisted_35 = { class: "w-full text-left table-auto min-w-max text-slate-800" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-slate-500 border-b border-slate-300 bg-slate-50" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-none font-normal" }, " Veri ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-none font-normal" }, " Veri Giriş Tarihi ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, [
      /*#__PURE__*/_createElementVNode("p")
    ])
  ])
], -1))
const _hoisted_37 = { class: "p-4" }
const _hoisted_38 = { class: "p-4" }
const _hoisted_39 = { class: "p-4 text-right" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
  })
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 0,
  colspan: "3",
  class: "p-4 text-center h-32"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.Loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `/classRoom/${_ctx.ClassRoom?.classRoomId}`,
                  class: "text-indigo-600 font-semibold flex items-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.ClassRoom?.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Avatar, {
                  photoUrl: _ctx.Student.photoUrl,
                  name: _ctx.Student.name,
                  surname: _ctx.Student.surname
                }, null, 8, ["photoUrl", "name", "surname"]),
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.Student.name) + " " + _toDisplayString(_ctx.Student.middleName) + " " + _toDisplayString(_ctx.Student.surname), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", null, _toDisplayString(_ctx.Student.schoolNumber), 1)
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(_ctx.Student.description), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("p", null, _toDisplayString(_ctx.Student.createdAt), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.Student.parent1FullName), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.Student.parent1PhoneNumber) + " / " + _toDisplayString(_ctx.Student.parent1Email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.Student.parent2FullName), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.Student.parent2PhoneNumber) + " / " + _toDisplayString(_ctx.Student.parent2Email), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.StudentAiData.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, "Öğrenciniz için henüz " + _toDisplayString(_ctx.ClassRoom?.name) + " sınıfı için yapay zeka eğitim verisi girilmemiş.", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("textarea", {
                  rows: "4",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
                  placeholder: "Veri...",
                  class: "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                }, null, 512), [
                  [_vModelText, _ctx.message]
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.AddStudentAiData && _ctx.AddStudentAiData(...args))),
                    class: "rounded-md bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  }, " Ekle ")
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("table", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StudentAiData, (item, classIndex) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: classIndex,
                        class: "hover:bg-slate-50"
                      }, [
                        _createElementVNode("td", _hoisted_37, _toDisplayString(item.dataText), 1),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(item.createdAt), 1),
                        _createElementVNode("td", _hoisted_39, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteData(item.studentDataId)),
                            class: "text-red-600 hover:text-red-800"
                          }, _hoisted_42, 8, _hoisted_40)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      (_ctx.StudentAiData.length == 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_43, " Bu öğrenciniz için henüz veri girilmemiş. "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}